import { Resource as ResourceType } from '../types';

const STATUS_CHOICES = [
  {
    id: 'pending',
    name: 'resource.validation_orders.field.status.choices.pending.label',
  },
  {
    id: 'incomplete',
    name: 'resource.validation_orders.field.status.choices.incomplete.label',
  },
  {
    id: 'success',
    name: 'resource.validation_orders.field.status.choices.success.label',
  },
  {
    id: 'error',
    name: 'resource.validation_orders.field.status.choices.error.label',
  },
];

export const validationOrder: ResourceType = {
  name: 'validation_orders',
  label: 'resource.validation_orders.label',
  hideResource: false,
  attributes: [
    {
      key: 'id',
      label: 'resource.validation_orders.field.id.label',
      type: 'text',
    },
    {
      key: 'project_reference',
      label: 'resource.validation_orders.field.project_reference.label',
      type: 'text',
    },
    {
      key: 'order_number',
      label: 'resource.validation_orders.field.order_number.label',
      type: 'text',
    },
    {
      key: 'period_start',
      label: 'resource.validation_orders.field.period_start.label',
      type: 'date',
    },
    {
      key: 'period_end',
      label: 'resource.validation_orders.field.period_end.label',
      type: 'date',
    },
    {
      key: 'order_confirmed_at',
      label: 'resource.validation_orders.field.order_confirmed_at.label',
      type: 'date',
    },
    {
      key: 'total_amount_ht',
      label: 'resource.validation_orders.field.total_amount_ht.label',
      type: 'number',
    },
    {
      key: 'status',
      label: 'resource.validation_orders.field.status.label',
      type: 'select',
      choices: STATUS_CHOICES,
    },
    {
      key: 'created_at',
      label: 'resource.validation_orders.field.created_at.label',
      type: 'date',
    },
    {
      key: 'updated_at',
      label: 'resource.validation_orders.field.updated_at.label',
      type: 'date',
    },
    {
      key: 'error',
      label: 'resource.validation_orders.field.error.label',
      type: 'text',
    },
    {
      key: 'synchronized_at',
      label: 'resource.validation_orders.field.synchronized_at.label',
      type: 'date',
    },
    {
      key: 'attachment',
      label: 'resource.validation_orders.field.attachment.label',
      type: 'buttons',
    },
    {
      key: 'client_id',
      label: 'resource.validation_orders.field.client_id.label',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'mission_id',
      label: 'resource.validation_orders.field.mission_id.label',
      type: 'reference',
      reference: 'missions',
    },
    {
      key: 'contract_milestone_id',
      label: 'resource.validation_orders.field.contract_milestone_id.label',
      type: 'reference',
      reference: 'contract_milestones',
    },
    {
      key: 'expert_id',
      label: 'resource.validation_orders.field.expert_id.label',
      type: 'reference',
      reference: 'users',
    },
    {
      key: 'client_invoice_id',
      label: 'resource.validation_orders.field.client_invoice_id.label',
      type: 'reference',
      reference: 'invoices',
    },
    {
      key: 'expert_invoice_id',
      label: 'resource.validation_orders.field.expert_invoice_id.label',
      type: 'reference',
      reference: 'invoices',
    },
  ],
  pages: {
    list: {
      hasEditButton: true,
      extensions: [{ key: 'validationOrdersDropzone' }],
      search: {
        enabled: true,
        label: 'filter.search.label',
      },
      fields: [
        { source: 'project_reference' },
        { source: 'order_number' },
        { source: 'order_confirmed_at' },
        { source: 'total_amount_ht' },
        {
          source: 'contract_milestone_id',
          label: 'resource.validation_orders.field.contract_milestone_id.label',
          link: true,
          child: { source: 'contract_milestones.title' },
        },
        {
          source: 'client_id',
          label: 'resource.validation_orders.field.client_id.label',
          link: true,
          child: { source: 'users.full_name' },
        },
        {
          source: 'mission_id',
          label: 'resource.validation_orders.field.mission_id.label',
          link: true,
          child: { source: 'missions.context' },
        },
        { source: 'status' },
      ],
      filters: [
        {
          source: 'status',
          type: 'select',
          label: 'resource.validation_orders.field.status.label',
          choices: STATUS_CHOICES,
        },
        {
          source: 'created_at',
          type: 'dateRange',
          label: 'resource.validation_orders.field.created_at.label',
          startLabel: 'resource.validation_orders.field.created_at_start.label',
          endLabel: 'resource.validation_orders.field.created_at_end.label',
        },
        {
          source: 'order_confirmed_at',
          type: 'dateRange',
          label: 'resource.validation_orders.field.order_confirmed_at.label',
          startLabel:
            'resource.validation_orders.field.order_confirmed_at_start.label',
          endLabel:
            'resource.validation_orders.field.order_confirmed_at_end.label',
        },
        {
          source: 'mission_id',
          type: 'reference',
          reference: 'missions',
          label: 'resource.validation_orders.field.mission_id.label',
          child: {
            type: 'autocomplete',
            optionText: 'context',
            options: {
              perPage: 50,
              allowEmpty: true,
              resettable: true,
              clearAlwaysVisible: true,
            },
          },
        },
      ],
      bulkActionButtons: [
        {
          name: 'synchronize',
          type: 'update',
          label:
            'resource.validation_orders.bulk_action_buttons.synchronize.label',
          extraUrl: '/synchronize',
          values: {},
          successMessage:
            'resource.validation_orders.notify.synchronize.started',
          refreshWhenDone: {
            property: 'status',
            whileIn: ['pending'],
            doneMessage: 'resource.validation_orders.notify.synchronize.done',
          },
        },
      ],
    },
    edit: {
      // Stay on this record's edit page after saving instead of react-admin's
      // default redirect to the index/list page.
      singleRedirect: {
        page: 'edit',
        basePath: '/validation_orders',
        recordId: 'id',
      },
      actions: [
        {
          name: 'synchronize',
          type: 'update',
          label: 'resource.validation_orders.action_buttons.synchronize.label',
          resourceId: 'id',
          extraUrl: '/synchronize',
          values: {},
          successMessage:
            'resource.validation_orders.notify.synchronize.started',
          refreshWhenDone: {
            property: 'status',
            whileIn: ['pending'],
            doneMessage: 'resource.validation_orders.notify.synchronize.done',
          },
        },
      ],
      left: {
        tabs: [
          {
            key: 'information',
            title: 'resource.validation_orders.tab.information.title',
            sections: [
              {
                key: 'information',
                title: 'resource.validation_orders.section.information.title',
                layout: [
                  ['order_number', 'project_reference'],
                  ['period_start', 'period_end'],
                  ['order_confirmed_at', 'total_amount_ht'],
                  ['status', 'synchronized_at'],
                  ['error'],
                ],
                inputs: {
                  order_number: { width: 6 },
                  project_reference: { width: 6, disabled: true },
                  period_start: { width: 6, disabled: true },
                  period_end: { width: 6, disabled: true },
                  order_confirmed_at: { width: 6 },
                  total_amount_ht: { width: 6, disabled: true },
                  status: { width: 6 },
                  synchronized_at: { disabled: true, width: 6 },
                  error: { disabled: true },
                },
                fields: {},
              },
              {
                key: 'pdf',
                title: 'resource.validation_orders.section.pdf.title',
                layout: [['attachment']],
                inputs: {},
                fields: {
                  attachment: {
                    label: 'resource.validation_orders.field.attachment.label',
                    addLabel: true,
                    extensions: [{ key: 'validationOrderPdf' }],
                  },
                },
              },
            ],
          },
        ],
      },
      right: [
        {
          sections: [
            {
              key: 'details',
              title: 'resource.validation_orders.section.details.title',
              layout: [['id'], ['created_at', 'updated_at']],
              inputs: {
                id: { disabled: true },
                created_at: { disabled: true, width: 6 },
                updated_at: { disabled: true, width: 6 },
              },
              fields: {},
            },
          ],
        },
        {
          sections: [
            {
              key: 'links',
              title: 'resource.validation_orders.section.links.title',
              layout: [
                ['client_id'],
                ['mission_id'],
                ['contract_milestone_id'],
                ['client_invoice_id'],
                ['expert_invoice_proforma_pdfs'],
                ['expert_invoice_id'],
              ],
              inputs: {},
              fields: {
                client_id: {
                  addLabel: true,
                  label: 'resource.validation_orders.field.client_id.label',
                  link: true,
                  child: { type: 'text', source: 'users.full_name' },
                },
                mission_id: {
                  addLabel: true,
                  link: true,
                  child: { type: 'text', source: 'missions.context' },
                },
                contract_milestone_id: {
                  addLabel: true,
                  link: true,
                  child: { type: 'text', source: 'contract_milestones.title' },
                },
                client_invoice_id: {
                  addLabel: true,
                  child: { type: 'text', source: 'invoice.guid' },
                },
                expert_invoice_proforma_pdfs: {
                  source: 'expert_invoice_id',
                  addLabel: true,
                  link: false,
                  label: 'resource.invoices.field.proforma_pdfs.label',
                  child: {
                    type: 'buttons',
                    source: 'invoice.proforma_pdfs',
                    extensions: [{ key: 'multipleLangFiles' }],
                  },
                },
                expert_invoice_id: {
                  addLabel: true,
                  child: { type: 'text', source: 'invoice.guid' },
                },
              },
            },
          ],
        },
        {
          sections: [
            {
              key: 'history',
              title: 'resource.validation_orders.section.history.title',
              layout: [],
              inputs: {},
              history: true,
              filterResource: 'validation_orders',
              filterAttribute: 'id',
            },
          ],
        },
      ],
    },
  },
};
